import { IUser } from './components/user_context_provider';
import { experimentBucket } from './user_context_helpers';
import { formatExperimentsForEventAttributes } from './elog/mparticle';
import { trackEvent } from './elog/mparticle_tracker';
import { MParticleEventName } from './elog/mparticle_types';
import { Commons_Cms_DynamicPageQuery } from './gql/graphql';

type Component = Commons_Cms_DynamicPageQuery['pages'][0]['components'][0];

interface FilterExperimentProps {
  component: Component;
  user: IUser;
}

interface TrackCmsExperimentsProps {
  components: Component[];
  user: IUser;
}

export function trackCmsExperimentQualifyingEvent({ components, user }: TrackCmsExperimentsProps) {
  const experiments = components.reduce((acc, c) => {
    if (c.experimentKey) acc.add(c.experimentKey);
    return acc;
  }, new Set<string>());

  if (!experiments.size) return;

  trackEvent({
    eventName: MParticleEventName.CmsExperimentQualifyingEvent,
    experiments: formatExperimentsForEventAttributes(user, Array.from(experiments)),
  });
}

export function cmsExperimentComponentFilter({ component, user }: FilterExperimentProps) {
  if (!component.experimentKey) { return true; }

  if (experimentBucket(user, component.experimentKey) === component.experimentBucket) {
    return true;
  }

  return false;
}
